import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";

export const useRagStatus = (projectId: string | undefined) => {

    const { data, isFetching, isPending, isError } = useQuery({
        queryKey: ["project-rag-status", projectId],
        queryFn: () => projectDetailsApi.fetchProjectRagStatus(projectId)
    });

    return {
        ragStatusData: data?.data,
        isPending, isFetching, isError
    }

}